// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3575":"d3f79e21","4655":"d3f79e21"}[chunkId] + ".chunk.css";
};